import React, { useEffect, useState } from 'react';
// import faqData from '../../../../Data/faq.json'
import { RegisterHeader } from '../../Components/Index';
import Footer from '../../../../Layout/Footer';
import bucketService from '../../../../Services/bucketService';
import toast, { Toaster } from 'react-hot-toast';
// import { Footer } from 'antd/lib/layout/layout';

const PoliceFAQ = () => {
  // State to track which item is open (null = all closed)
  const [openIndex, setOpenIndex] = useState(null);
  const [faqData, setFaqData] = useState<any>()

  const toggleFAQ = (index: any) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const getFaq = async () => {
    try {
      const response = await bucketService.faq()
      if (response.data) {
        setFaqData(response.data)
      }
    } catch (error) {
      toast.error('Unable to load Faq')
    }
  }
  useEffect(() => {
    getFaq()
  }, [])
  return (
    <>
    <RegisterHeader/>
    <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light bg-opacity-25 p-4">

      {/* Main Container Card */}
      <div
        className="card border-0 py-5 my-5  shadow-sm w-100 overflow-show"
        style={{ maxWidth: '800px', borderRadius: '30px', backgroundColor: '#ffffffff' }}
      >
        <div className="card-body ">

          {/* Header & Search */}
          <div className="row align-items-center my-4 g-3">
            <div className="col-md-6 pl-4">
              <h1 className="fw-bolder display-6 m-0 text-dark">FAQ</h1>
            </div>

            {/* <div className="col-md-6">
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control rounded-pill border-0 shadow-sm py-2 ps-4 pe-5"
                  placeholder="Search..."
                  style={{ height: '50px' }}
                />
<i
                  className="fa fa-search position-absolute text-muted"
                  aria-hidden="true"
                  style={{
                    top: '50%',
                    right: '20px',
                    transform: 'translateY(-50%)',
                    fontSize: '20px'
                  }}
                ></i>
              </div>
            </div> */}
          </div>

          {/* FAQ Items List */}
          <div className="d-flex flex-column gap-3">
            {faqData && faqData?.faqs?.map((item: any, index: any) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={item.id}
                  className="card border-0 shadow-lg bg-white"
                  style={{ borderRadius: '15px', overflow: 'hidden' }}
                >
                  {/* Clickable Header */}
                  <div
                    className="card-header bg-white border-0 p-4 d-flex justify-content-between align-items-center"
                    onClick={() => toggleFAQ(index)}
                    style={{ cursor: 'pointer' }}
                  >
                    <h6 className="fw-bold m-0 text-dark pe-3">{item.question}</h6>
                  {isOpen
                    ? (
                      <i className="fa fa-chevron-up text-success flex-shrink-0" style={{ fontSize: '20px' }}></i>
                      )
                    : (
                      <i className="fa fa-chevron-down text-success flex-shrink-0" style={{ fontSize: '20px' }}></i>
                      )}
                  </div>

                  {/* Collapsible Body */}
                  <div
                    className={`collapse ${isOpen ? 'show' : ''}`}
                    style={{ transition: 'all 0.3s ease' }}
                  >
                    <div
                      className="card-body px-4 pb-4 pt-0 text-secondary bold"
                      // This ensures the \n in your JSON render as line breaks
                      style={{ whiteSpace: 'pre-line', fontSize: '16px' }}
                    >
                      {item.answer}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

        </div>
      </div>
    </div>
    <Toaster />
    <Footer />
    </>
  );
};

export default PoliceFAQ
